import { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';
import { clearAllCache } from '../utils/cacheUtils';

const UserSessionContext = createContext({});

export const useUserSession = () => {
    const context = useContext(UserSessionContext);
    if (!context) {
        throw new Error('useUserSession must be used within a UserSessionProvider');
    }
    return context;
};

export const UserSessionProvider = ({ children }) => {
    const { user } = useAuth();
    const [impersonatedUserId, setImpersonatedUserId] = useState(null);

    // Determine effective user ID
    const effectiveUserId = impersonatedUserId || user?.uid;
    const isImpersonating = !!impersonatedUserId;

    const startImpersonation = (targetUserId) => {
        // if (!isAdmin) {
        //     throw new Error('Only admin users can impersonate others');
        // }

        console.log('Starting impersonation, clearing all cache...', {
            admin: user?.uid?.substring(0, 8) + '...',
            target: targetUserId.substring(0, 8) + '...'
        });

        // Clear all cached data before impersonating
        clearAllCache();

        setImpersonatedUserId(targetUserId);
    };

    const stopImpersonation = () => {
        console.log('Stopping impersonation, clearing all cache...', {
            returning: user?.uid?.substring(0, 8) + '...'
        });

        // Clear all cached data when returning to admin user
        clearAllCache();

        setImpersonatedUserId(null);
    };

    const sessionValue = {
        effectiveUserId,
        realUserId: user?.uid,
        isImpersonating,
        impersonatedUserId,
        startImpersonation,
        stopImpersonation
    };

    // Store session globally for external access
    currentUserSession = sessionValue;

    return (
        <UserSessionContext.Provider value={sessionValue}>
            {children}
        </UserSessionContext.Provider>
    );
};

// Export function for external access (used by authUtils)
export const getCurrentUserSession = () => {
    return currentUserSession;
};

let currentUserSession = null;
